import { Tag } from 'antd'
import React from 'react'
import { CandidateStatus } from '../candidate'
import { useTranslation } from 'react-i18next'

const statusColors: Record<CandidateStatus, string> = {
    new: 'blue',
    contacted: 'orange',
    conversation: 'green',
    finished: 'gray',
}

export function CandidateStatusTag({ status }: { status: CandidateStatus }) {
    const { t } = useTranslation()

    return (
        <Tag
            className="self-start"
            color={statusColors[status]}
        >
            {t(`candidateStatus.${status}`)}
        </Tag>
    )
}

export const candidateStatusTableFilters = Object.keys(statusColors).map((status) => ({
    value: status,
    text: (
        <CandidateStatusTag
            status={status as CandidateStatus}
            key={status}
        />
    ),
}))
